import { useGlobalWebAudioContext, IUseWebAudioResult } from './index';
import { useCallback, useRef } from 'react';

interface IUseBufferAudioResult extends Pick<IUseWebAudioResult, 'suspend' | 'close' | 'resume'> {
  play: (buffer: ArrayBuffer) => Promise<boolean>;
  isPlay: boolean;
}

/** 局部hooks引用全局Context，play方法添加唯一id */
const useBufferAudio = (): IUseBufferAudioResult => {
  const ctx = useGlobalWebAudioContext();
  const idRef = useRef<symbol>(Symbol(''));

  const play = useCallback((buffer: ArrayBuffer) => {
    return ctx.play(buffer, idRef.current);
  }, []);
  return {
    suspend: ctx.suspend,
    close: ctx.close,
    resume: ctx.resume,
    play,
    isPlay: ctx.isPlay && idRef.current === ctx.playId
  };
};

export default useBufferAudio;
